import { IconType } from 'react-icons'
import {
  SiFacebook,
  SiFramer,
  SiGmail,
  SiGoogle,
  SiGoogleads,
  SiGoogledrive,
  SiLinkedin,
  SiShopify,
  SiWebflow,
  SiWordpress,
} from 'react-icons/si'
import { IntegrationType } from 'sprites-types/api/v2/integrations'

export type IntegrationConfig = {
  name: string
  displayName: string
  icon: IconType
  iconColor: string
  iconBgColor: string
  primaryColor: string
  authMethod: 'oauth' | 'credentials'
  shouldColorIcon: boolean // If true, apply color via className; if false, icon has built-in colors
}

export const INTEGRATION_CONFIGS: Record<IntegrationType, IntegrationConfig> = {
  facebook: {
    name: 'facebook',
    displayName: 'Meta Ads',
    icon: SiFacebook,
    iconColor: 'text-blue-600',
    iconBgColor: 'bg-blue-100',
    primaryColor: '#1877F2',
    authMethod: 'oauth',
    shouldColorIcon: false,
  },
  googleAds: {
    name: 'googleAds',
    displayName: 'Google Ads',
    icon: SiGoogleads,
    iconColor: 'text-blue-600',
    iconBgColor: 'bg-blue-100',
    primaryColor: '#4285F4',
    authMethod: 'oauth',
    shouldColorIcon: false,
  },
  googleSearchConsole: {
    name: 'googleSearchConsole',
    displayName: 'Google Search Console',
    icon: SiGoogle,
    iconColor: 'text-blue-600',
    iconBgColor: 'bg-blue-100',
    primaryColor: '#4285F4',
    authMethod: 'oauth',
    shouldColorIcon: false,
  },
  shopify: {
    name: 'shopify',
    displayName: 'Shopify',
    icon: SiShopify,
    iconColor: 'text-green-600',
    iconBgColor: 'bg-green-100',
    primaryColor: '#96BF48',
    authMethod: 'credentials',
    shouldColorIcon: true,
  },
  wordpress: {
    name: 'wordpress',
    displayName: 'WordPress',
    icon: SiWordpress,
    iconColor: 'text-blue-600',
    iconBgColor: 'bg-blue-100',
    primaryColor: '#21759B',
    authMethod: 'credentials',
    shouldColorIcon: true,
  },
  gmail: {
    name: 'gmail',
    displayName: 'Gmail',
    icon: SiGmail,
    iconColor: 'text-red-600',
    iconBgColor: 'bg-red-100',
    primaryColor: '#EA4335',
    authMethod: 'oauth',
    shouldColorIcon: false,
  },
  google_drive: {
    name: 'google_drive',
    displayName: 'Google Drive',
    icon: SiGoogledrive,
    iconColor: 'text-blue-600',
    iconBgColor: 'bg-blue-100',
    primaryColor: '#4285F4',
    authMethod: 'oauth',
    shouldColorIcon: false,
  },
  linkedin: {
    name: 'linkedin',
    displayName: 'LinkedIn',
    icon: SiLinkedin,
    iconColor: 'text-blue-700',
    iconBgColor: 'bg-blue-100',
    primaryColor: '#0077B5',
    authMethod: 'oauth',
    shouldColorIcon: false,
  },
  webflow: {
    name: 'webflow',
    displayName: 'Webflow',
    icon: SiWebflow,
    iconColor: 'text-indigo-600',
    iconBgColor: 'bg-indigo-100',
    primaryColor: '#4353FF',
    authMethod: 'oauth',
    shouldColorIcon: true,
  },
  framer: {
    name: 'framer',
    displayName: 'Framer',
    icon: SiFramer,
    iconColor: 'text-purple-600',
    iconBgColor: 'bg-purple-100',
    primaryColor: '#0055FF',
    authMethod: 'credentials',
    shouldColorIcon: true,
  },
}

export function getIntegrationConfig(integrationType: string): IntegrationConfig | undefined {
  return INTEGRATION_CONFIGS[integrationType as IntegrationType]
}
